import { cn } from "logic/utils";
import Image from "next/image";
import { ReactNode } from "react";

export interface SelectOption {
  value: string;
  label: string;
  icon?: string;
  suffix?: ReactNode;
}

interface SelectOptionItemProps {
  id?: string;
  option: SelectOption;
  isSelected: boolean;
  isHighlighted?: boolean;
  onSelect: (value: string) => void;
}

export function SelectOptionItem(props: SelectOptionItemProps) {
  const { id, option, isSelected, isHighlighted = false, onSelect } = props;

  return (
    <button
      id={id}
      className={cn(
        "w-full px-4 py-3 text-left text-text-secondary transition-colors flex items-center justify-between",
        "hover:bg-bg-secondary focus:bg-bg-secondary outline-none",
        isHighlighted && "bg-bg-secondary",
        isSelected && "bg-bg-primary font-medium text-primary",
      )}
      onClick={() => onSelect(option.value)}
      type="button"
      role="option"
      aria-selected={isSelected}
    >
      <span className="flex items-center gap-2">
        {option.icon && <Image src={option.icon} alt="" width={20} height={20} className="shrink-0" />}
        {option.label}
      </span>
      {option.suffix}
    </button>
  );
}
